import { CustomButton } from "@/components/ui/Buttons";
import logo from "@/assets/logo/full-logo.png";
import { Link } from "react-router-dom";

const AssignmentHeader = ({
  onSubmit,
  loading,
  disabled,
}: {
  disabled:boolean,
  loading: boolean;
  onSubmit: () => void;
}) => {
  return (
    <header className="border-b border-[#F0F0F3] sticky top-0 left-0 bg-white">
      <div className="max-w-7xl  px-4 mx-auto py-2.5 flex items-center justify-between">
        <Link to={"/"}>
          <img src={logo} alt="passionbits logo" />
        </Link>
        <div className="flex gap-4">
          <Link to={"/"}>
            <CustomButton
              variant="outline"
              color="#344054"
              fontSize="14px"
              fontWeight="500"
              padding="8px 24px"
              border="1px solid #E8EBEE"
              borderRadius="8px"
              className="leading-5"
            >
              Cancel
            </CustomButton>
          </Link>
          <CustomButton
            fontSize="14px"
            onClick={onSubmit}
            fontWeight="500"
            disabled={loading || disabled}
            padding="8px 24px"
            backgroundColor="#17457D"
            borderRadius="8px"
            className="leading-5"
          >
            {loading ? "Submitting... " : "Submit"}
          </CustomButton>
        </div>
      </div>
    </header>
  );
};

export default AssignmentHeader;
